import { trackStructEvent } from "@rtl_nl/rtl-snowplow";
import { globalVars } from "./variables";
import { waitForElm } from "./helperFunctions";

/**
 *
 */
function initHeaderTracking() {
    const logo = document.querySelector('.vl-menu__logo');
    if (logo) {
        logo.addEventListener('click', (e) => {
            trackStructEvent({
                appId: globalVars.app_id,
                category: globalVars.page_type,
                action: "click-main-logo",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "header",
                    elementType: "section",
                    elementName: "videoland",
                    elementLabel: "videoland",
                    elementStyle: "icon"
                },
            });
        });
    }
    const loginLink = document.querySelector('.vl-menu__login');
    if (loginLink) {
        loginLink.addEventListener('click', (e) => {
            trackStructEvent({
                appId: globalVars.app_id,
                category: globalVars.page_type,
                action: "start-login",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "header",
                    elementType: "button",
                    elementName: "cta-al-abonne",
                    elementLabel: "Al Abonnee?",
                    elementStyle: "primary"
                },
            });
        });
    }
    const mainLoginBtn = document.querySelector(".btn.white-transparency.vl-loggedin-hide");
    if (mainLoginBtn) {
        mainLoginBtn.addEventListener("click", (e) => {
            trackStructEvent({
                appId: globalVars.app_id,
                category: globalVars.page_type,
                action: "start-login",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "header",
                    elementType: "button",
                    elementName: "cta-login",
                    elementLabel: "Inloggen",
                    elementStyle: "primary"
                },
            });
        });
    }

    const trialButton = document.querySelector(".btn.watch-cta.vl-loggedin-hide");
    if (trialButton) {
        trialButton.addEventListener("click", (e) => {
            trackStructEvent({
                appId: globalVars.app_id,
                category: globalVars.page_type,
                action: "start-trial",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "header",
                    elementType: "button",
                    elementName: "cta-trial",
                    elementLabel: "Probeer het 14 dagen",
                    elementStyle: "primary"
                },
            });
        });
    }

    waitForElm(".sticky-button-wrapper a.btn").then(() => {
        const stickyButton = document.querySelector(".sticky-button-wrapper a.btn");
        console.log(stickyButton);
        if (stickyButton) {
            stickyButton.addEventListener("click", (e) => {
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: globalVars.page_type,
                    action: "start-trial",
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: "sticky-button",
                        elementType: "button",
                        elementName: "cta-trial",
                        elementLabel: "Probeer het 14 dagen",
                        elementStyle: "icon"
                    },
                });
            });
        }
    });
}

export { initHeaderTracking };
